import { useEffect } from "react";
import { head } from "lodash";
import { Project } from "@radarly/models/project";
import { User } from "@radarly/models/user";

declare global {
  interface Window {
    FS: any;
    pendo: any;
  }
}

function identifyFullStory(user: User) {
  if (window.FS) {
    window.FS.identify(user.id, {
      displayName: user.name,
      email: user.email,
    });
  }
}
function initializePendo(user: User, project: Project) {
  if (window.pendo) {
    window.pendo.initialize({
      visitor: {
        id: user.id,
        creation_date: user.created,
        email: user.email,
        full_name: user.name,
        language: user.locale,
        access_level: (user as any).level,
        access_to_radarly: user.apps.indexOf("radarly") !== -1,
        access_to_tribes: user.apps.indexOf("kol") !== -1,
        access_to_search: user.apps.indexOf("linkfluence_search") !== -1,
        sfdc_id: head(project?.sfdcIds)?.id,
      },
      account: {
        id: user.accountId,
        name: user.accountLabel,
        type: user.accountType,
      },
    });
  }
}

export const useInitTrackers = (user: User, project: Project) => {
  useEffect(() => {
    if (user?.id) {
      initializePendo(user, project);
      identifyFullStory(user);
    }
  }, [project, user]);
};
